export var IconPosition;
(function (IconPosition) {
    IconPosition["Left"] = "left";
    IconPosition["Right"] = "right";
})(IconPosition || (IconPosition = {}));
